import { useCallback, useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const weekLabel = (week) => new Date(`${week}T00:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric" });

export function WeeklyHoursTable({ weeks, rows, testId, emptyText }) {
  return (
    <table className="requests-table connecteam-table weekly-hours-table" data-testid={testId}>
      <thead><tr><th>Person</th><th>Client / site</th>{weeks.map((week) => <th key={week}>Wk of {weekLabel(week)}</th>)}<th>Total</th></tr></thead>
      <tbody>
        {rows.map((row) => (
          <tr key={`${row.provider_id || row.connecteam_user_id}-${row.client_id || row.client_name}`} data-testid={`${testId}-row-${row.provider_id || row.connecteam_user_id}-${row.client_id || "nosite"}`}>
            <td><strong>{row.person_name}</strong>{!row.mapped && <><br /><small className="pairing-meta">not mapped to TAGForce</small></>}</td>
            <td>{row.client_name}</td>
            {weeks.map((week) => <td key={week}>{row.weeks[week] != null ? row.weeks[week].toFixed(2) : <span className="pairing-meta">—</span>}</td>)}
            <td><strong>{row.total.toFixed(2)}</strong></td>
          </tr>
        ))}
        {!rows.length && <tr><td colSpan={weeks.length + 3} className="provider-empty-state" data-testid={`${testId}-empty`}>{emptyText}</td></tr>}
      </tbody>
    </table>
  );
}

export function WeeklyHoursPanel() {
  const [data, setData] = useState(null);
  const [weeks, setWeeks] = useState(6);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      setData((await api.get(`/connecteam/weekly-hours?weeks=${weeks}`)).data);
    } catch (requestError) {
      setError(formatApiError(requestError));
    }
  }, [weeks]);

  useEffect(() => {
    load();
  }, [load]);

  if (error) return <p className="form-message error-message" data-testid="weekly-hours-error">{error}</p>;
  if (!data) return <p className="projection-loading">Loading weekly hours…</p>;
  return (
    <section className="connecteam-panel" data-testid="connecteam-weekly-hours">
      <div className="section-heading">
        <div>
          <h2><CalendarClock size={16} /> Weekly hours worked per provider per client</h2>
          <p>Completed time clock entries, grouped by ET week (Monday–Sunday) and by the client mapped to the Connecteam site. Visible to the System Administrator and HR only.</p>
        </div>
        <label>Weeks<select data-testid="weekly-hours-weeks" value={weeks} onChange={(e) => setWeeks(Number(e.target.value))}>{[4, 6, 8, 12].map((n) => <option key={n} value={n}>{n}</option>)}</select></label>
      </div>
      <div className="requests-table-panel">
        <WeeklyHoursTable weeks={data.weeks} rows={data.rows} testId="weekly-hours-table" emptyText="No completed time entries in this window." />
      </div>
    </section>
  );
}
